import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Page from './page';
import ButtonNext from './ButtonNext';
import Api from '../../util/api';
import ResultAbResultSet from '../../util/ResultAbResultSet';
import Option from './Option';

const ResultAB = ({navigateDeviceNext = false, question, answer, id, screenshot, text}) => {
    const [data, setData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            let response = await Api.getData(id);

            setData(ResultAbResultSet.fromResponse(response));
        }

        fetchData().then();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (data === null) {
        return <Page title={'Loading'}>Loading ...</Page>;
    }

    return (
        <Page title={'Target Group Selection'}>
            <div className={'bodyContainer'} style={{justifyContent: 'center'}}>
                <div style={styles.container}>
                    <div style={styles.title}>{question}</div>

                    <div style={styles.resultContainer}>
                        <div style={styles.columnLeft}>
                            <div>
                                <img src={screenshot} alt={'screenshot'} style={{borderRadius: '8px', width: '100%'}}/>
                            </div>
                        </div>
                        <div style={styles.columnRight}>
                            <div style={styles.question}>
                                {text}
                            </div>
                            <Option selected={answer === 1} type={'OK'} loaded={data['OK']}/>
                            <Option selected={answer === 2} type={'NOK'} loaded={data['NOK']}/>
                        </div>
                    </div>

                    <div style={{marginTop: '120px', width: '100%'}}>
                        <ButtonNext navigateDeviceNext={navigateDeviceNext}/>
                    </div>
                </div>
            </div>
        </Page>
    );
}

ResultAB.propTypes = {
    navigateDeviceNext: PropTypes.bool,
    question: PropTypes.string.isRequired,
    answer: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
    screenshot: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '80vw',
    },
    resultContainer: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
    },
    columnLeft: {
        display: 'flex',
        width: 'calc(50% - 25px)',
        justifyContent: 'center',
        alignItems: 'flex-start',
    },
    columnRight: {
        display: 'flex',
        flexDirection: 'column',
        width: 'calc(50% - 25px)',
    },
    title: {
        borderBottom: '9px solid #68c4d6',
        color: '#e4195f',
        display: 'flex',
        justifyContent: 'center',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
        fontSize: '36px',
        lineHeight: '36px',
        fontStyle: 'italic',
        paddingBottom: '25px',
        marginBottom: '105px',
        width: '100%',
    },
    question: {
        color: '#427A83',
        width: '100%',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
        fontSize: '22px',
        marginBottom: '25px',
        textAlign: 'center',
    },
}

export default ResultAB;
